import React, { useState, useEffect } from "react";
import { formatDateTime } from "../utils/formatDate";
import { useNavigate, useLocation } from "react-router-dom";
import AttemptQuestions from "../Components/AttemptQuestions";
import { Dropdown } from "react-bootstrap";
import { FaArrowLeft } from "react-icons/fa";
import axios from "axios";
import "../App.css";
import formatName from "../utils/formatName";

function ViewAttempts() {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    assessmentId,
    userId: viewedUserId,
    userName: viewedUserName,
  } = location.state || {};
  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState("");
  const [attempts, setAttempts] = useState([]);
  const [selectedAttempt, setSelectedAttempt] = useState("");
  const [selectedAttemptId, setSelectedAttemptId] = useState(null);

  useEffect(() => {
    if (viewedUserId) {
      setUserId(viewedUserId);
      setUserName(viewedUserName || "User");
      return;
    }

    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        if (parsedUser && parsedUser.user_id) {
          setUserId(parsedUser.user_id);
          setUserName(parsedUser.username || "User");
        }
      } catch (error) {
        console.error("Error parsing user from localStorage:", error);
      }
    }
  }, [viewedUserId, viewedUserName]);

  useEffect(() => {
    const fetchAttempts = async () => {
      if (!userId || !assessmentId) return;
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}/numAttempts`,
          {
            params: {
              assessment_id: assessmentId,
              user_id: userId,
            },
          }
        );

        if (response.data.success) {
          const formattedAttempts = response.data.data.map((item) => ({
            id: item.attempt,
            text: `Attempt ${item.attempt} - ${formatDateTime(
              item.created_at
            )}`,
          }));

          setAttempts(formattedAttempts);
          setSelectedAttempt(formattedAttempts[0]?.text || "No Attempts Found");
          setSelectedAttemptId(formattedAttempts[0]?.id || null);
        }
      } catch (error) {
        console.error("Error fetching attempts:", error);
      }
    };

    fetchAttempts();
  }, [userId, assessmentId]);

  const handleAttemptSelect = (eventKey) => {
    const selectedAttemptObj = attempts.find(
      (attempt) => String(attempt.id) === String(eventKey)
    );
    setSelectedAttempt(selectedAttemptObj?.text || "No Attempt Selected");
    setSelectedAttemptId(eventKey);
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div className="container mt-3 bg-light">
      <div
        className="d-flex align-items-center p-3"
        style={{
          background: "#263F86",
          borderRadius: "5px",
          color: "white",
          fontFamily: "Manrope-Regular",
        }}
      >
        <div className="d-flex align-items-center gap-3">
          <FaArrowLeft
            style={{
              cursor: "pointer",
              color: "#ffffff",
              fontSize: "1.2rem",
            }}
            onClick={handleBackClick}
          />

          <Dropdown>
            <Dropdown.Toggle variant="outline-light" id="dropdown-attempts">
              {selectedAttempt || "Loading..."}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {attempts.map((attempt) => (
                <Dropdown.Item
                  key={attempt.id}
                  eventKey={attempt.id}
                  onClick={() => handleAttemptSelect(attempt.id)}
                >
                  {attempt.text}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>

        <span
          className="ms-auto"
          style={{
            fontSize: "1rem",
            fontWeight: "bold",
          }}
        >
          {formatName(userName)}
        </span>
      </div>

      <AttemptQuestions attemptId={selectedAttemptId} />
    </div>
  );
}

export default ViewAttempts;
